var components
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var m0 = require("../../static/nantouxiang.png")

  var m1 = require("../../static/nantouxiang.png")

  var m2 = require("../../static/nvtouxiang.png")

  var m3 = require("../../static/nantouxiang.png")

  var m4 = require("../../static/nvtouxiang.png")

  var m5 = require("../../static/nantouxiang.png")

  var m6 = require("../../static/nvtouxiang.png")

  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        m0: m0,
        m1: m1,
        m2: m2,
        m3: m3,
        m4: m4,
        m5: m5,
        m6: m6
      }
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }